import React, { useState } from 'react';
import './App.css';
import ScoreBoard from './components/ScoreBoard';

function App() {
  const [totalScore, setTotalScore] = useState<number>(0);

  return (
    <div className="App">
      <h1>Yamb Score Card</h1>
      <div className={'rules'}><a href={'https://caranmegil.com/Yamb.pdf'} rel={'noreferrer'} target={'_blank'}>The Rules</a></div>
      <div className={'total-score'}>Total Score: {totalScore}</div>
      <div className={'banner'}>{`Roll them bones!`}</div>
      <div className={'game-sheet'}>
        <ScoreBoard totalScore={totalScore} setTotalScore={(newTotalScore: number) => setTotalScore(newTotalScore)} />
      </div>
    </div>
  );
}

export default App;
